module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper background-white",
    attrs: {
      "align": "center"
    }
  }, [(_vm.isSuccessModalVisible) ? _c('success') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [(_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center pv"
  }, [_vm._v("Multi-factor Authentication")]), _vm._v(" "), _c('p', {
    staticClass: "text-center pv"
  }, [_vm._v("Please enter the code sent to your email.")]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateMfaAndSubmitLogin()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mfaCode),
      expression: "mfaCode"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mfaCode",
      "type": "text",
      "placeholder": "Enter the code",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.mfaCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mfaCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedMfa
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), _c('p', {
    staticClass: "pt-lg text-center border-top mt-xl"
  }, [_vm._v("\n          Back to "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.backToLogin
    }
  }, [_vm._v("login")])])]) : _vm._e(), _vm._v(" "), (!_vm.needsMfa) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("Log in to your account below | "), _c('a', {
    staticClass: "text-muted cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRedirection()
      }
    }
  }, [_vm._v("First time user?")])]), _vm._v(" "), _c('strong', [_c('p', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.otherErrors))])]), _vm._v(" "), (_vm.isUserIdle) ? _c('p', [_c('strong', {
    staticClass: "text-red"
  }, [_vm._v("You have been logged out of your account due to inactivity.")])]) : _vm._e(), _vm._v(" "), (_vm.fromPasswordResetEmail) ? _c('p', [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v("Your password has been reset successfully.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control shadow",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter Email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.passwordError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control shadow",
    attrs: {
      "id": "signupInputPassword1",
      "type": "password",
      "placeholder": "Enter Password",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock4"
    }
  }, [_vm._v(_vm._s(_vm.passwordError))])]), _vm._v(" "), _c('div', {
    staticClass: "direction-row"
  }, [_c('div', [_c('a', {
    staticClass: "text-muted cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRedirection('reset-password')
      }
    }
  }, [_vm._v("Forgot your password?")])]), _vm._v(" "), _c('div', {
    staticClass: "direction-row"
  }, [_c('a', {
    staticClass: "text-muted no-underline mr-1 cursor-pointer",
    on: {
      "click": function($event) {
        _vm.handleRememberMe()
      }
    }
  }, [_vm._v("\n                Remember Me\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "checkbox-shadow cursor-pointer",
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "rememberMe"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, "") > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-pill btn-default btn-lg mt-lg pull-left mb-0",
    attrs: {
      "type": "submit",
      "disabled": _vm.submittedForm
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.loginError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.loginError))])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('em', {
    staticClass: "icon-lock"
  }), _vm._v("\n            Log In\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe4b5f1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmbedLogin.vue
// module id = 2212
// module chunks = 1